import Message from "./CMessage/index";

export default Message;
